import { Selecting, useToastProvider } from '@qualio/ui-components';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { DocumentStatus } from '../../../../../../../../api/model/document';
import { useTableDataInvalidation } from '../../../../hooks/useTableDataInvalidation';
import { WorkspaceTabs } from '../../../../WorkspaceV2';
import {
  hasAllowedStatusesForAction,
  hasRequiredPermissionsForAction,
  isValidTabForAction,
} from '../../../BulkActions';
import { BulkActionButton } from '../../BulkActionButton/index';
import { handleStatusChange } from '../ChangeStatusService';
import {
  ChangeStatusButtonProps,
  IsChangeStatusActionAllowedCallback,
} from '../types';

export const SendForApprovalButton = (props: ChangeStatusButtonProps) => {
  const { t } = useTranslation();
  const { showToast } = useToastProvider();
  const [isLoading, setIsLoading] = useState(false);
  const selection = Selecting.useSelectionMaybe();
  const { invalidate } = useTableDataInvalidation();
  const toastActionStringActive = t('buttons.sendForApproval').toLowerCase();
  const toastActionStringPassive = t('notifications.sentForApproval')
    .toLowerCase()
    .replace('!', '');

  const handleSendForApproval = async () => {
    setIsLoading(true);
    await handleStatusChange(
      props.selectedDocuments,
      { status: DocumentStatus.For_Approval },
      selection?.setSelection as any,
      showToast,
      toastActionStringActive,
      toastActionStringPassive,
    );
    setIsLoading(false);
    void invalidate(props.currentTab);
  };

  const canSendForApproval: IsChangeStatusActionAllowedCallback = (
    user,
    statuses,
    activeTab,
    requiredPermissions,
  ) => {
    if (
      !hasRequiredPermissionsForAction(requiredPermissions, user.permissions) ||
      !isValidTabForAction([WorkspaceTabs.YOUR_DOCUMENTS], activeTab)
    ) {
      return false;
    }
    return hasAllowedStatusesForAction(
      [DocumentStatus.Draft, DocumentStatus.For_Review],
      statuses,
    );
  };

  return (
    <BulkActionButton
      {...props}
      isActionAllowed={canSendForApproval}
      onClick={handleSendForApproval}
      isLoading={isLoading}
    />
  );
};
